function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M33 1L1 33",
  stroke: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33 1L1 33",
  stroke: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 1l32 32",
  stroke: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1 1l32 32",
  stroke: "#fff"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzQgMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zMyAxTDAuOTk5OTk3IDMzIiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zMyAxTDAuOTk5OTk3IDMzIiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xIDFMMzMgMzMiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTEgMUwzMyAzMyIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgClose as ReactComponent };